"use strict";
var $gOPD = require("./gOPD");
if ($gOPD) {
  try {
    $gOPD([], "length");
  } catch (e) {
    $gOPD = null;
  }
}
module.exports = $gOPD;
